var _g, _circle, _circle2, _rect, _g2, _circle3, _g3, _rect2, _rect3, _rect4, _g4, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 660,
    viewBox: "0 0 350 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1325_7193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4619 627C83.3929 627 131.478 614.816 173.962 593.204M148.962 24.4382C171.363 33.4438 192.48 44.969 211.962 58.6632",
    stroke: "#0C00FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 217.962 566)",
    fill: "#0C00FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 55.9619 3)",
    fill: "#0C00FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.44949,
    y: 1.41421,
    width: 256,
    height: 377,
    rx: 22,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 345.512 147.707)",
    fill: "#F5F6F8",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1325_7193)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 50,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 193.074 231.524)",
    fill: "url(#paint0_linear_1325_7193)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 193.074 231.524)",
    stroke: "url(#paint1_linear_1325_7193)",
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1325_7193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 181,
    width: 101,
    height: 101
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 50,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 193.074 231.524)",
    fill: "url(#paint2_linear_1325_7193)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1325_7193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.289 257.674C203.506 259.072 208.873 255.96 210.265 250.764L214.907 233.438C217.938 222.129 211.227 210.506 199.918 207.475C188.609 204.445 176.985 211.156 173.955 222.465L169.313 239.791C167.916 245.005 171.011 250.365 176.23 251.763L198.289 257.674Z",
    fill: "#1A358F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.185 239.585L200.086 244.65L192.911 271.426L174.01 266.362L181.185 239.585Z",
    fill: "#77A1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.494 237.31L209.65 240.46C207.09 250.013 197.234 255.703 187.681 253.144C178.128 250.584 172.438 240.728 174.998 231.175L175.842 228.025C176.541 225.415 179.223 223.866 181.833 224.566C187.319 226.036 192.912 224.194 196.49 220.267C197.626 225.457 201.549 229.848 207.035 231.318C209.644 232.018 211.193 234.7 210.494 237.31Z",
    fill: "#BED2F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.883 259.242L176.965 255.336C179.096 258.017 182.033 260.071 185.571 261.019C189.109 261.967 192.679 261.657 195.837 260.393L210.438 273.324C213.211 275.782 214.357 279.597 213.398 283.175L212.433 286.777C212.198 287.651 211.301 288.171 210.419 287.935L150.594 271.905C149.716 271.669 149.192 270.78 149.429 269.895L150.394 266.294C151.353 262.715 154.252 259.984 157.883 259.242Z",
    fill: "#3954AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.727 264.169C179.838 262.859 175.814 259.938 173.059 256.135L176.964 255.336C179.096 258.017 182.033 260.071 185.571 261.019C189.108 261.966 192.679 261.657 195.837 260.393L198.837 263.05C194.552 264.962 189.612 265.478 184.727 264.169Z",
    fill: "#1A358F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 8,
    rx: 4,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 251.057 331.953)",
    fill: "#BED2F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1.22474,
    y: 0.707107,
    width: 210,
    height: 30,
    rx: 7,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 263.214 370.713)",
    fill: "url(#paint3_linear_1325_7193)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1.22474,
    y: 0.707107,
    width: 210,
    height: 30,
    rx: 7,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 252.863 409.35)",
    fill: "url(#paint4_linear_1325_7193)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1325_7193)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 12,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 294.962 474.706)",
    fill: "#F5F6F8",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.44949,
    y: 1.41421,
    width: 76,
    height: 76,
    rx: 10,
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 290.512 474.12)",
    stroke: "url(#paint5_linear_1325_7193)",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249 522.642C252.616 523.611 256.335 521.454 257.3 517.853L260.518 505.845C262.618 498.006 257.967 489.95 250.129 487.85C242.291 485.75 234.235 490.401 232.135 498.239L228.917 510.248C227.949 513.861 230.094 517.576 233.711 518.545L249 522.642Z",
    fill: "#BED2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.145 510.105L250.245 513.615L245.272 532.173L232.172 528.663L237.145 510.105Z",
    fill: "#F3F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.459 508.528L256.874 510.711C255.1 517.332 248.269 521.276 241.648 519.502C235.027 517.728 231.083 510.897 232.857 504.276L233.442 502.093C233.927 500.284 235.786 499.211 237.595 499.695C241.397 500.714 245.273 499.438 247.753 496.716C248.54 500.313 251.259 503.357 255.061 504.375C256.87 504.86 257.943 506.719 257.459 508.528Z",
    fill: "#F3F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.995 523.728L234.22 521.022C235.697 522.88 237.733 524.303 240.185 524.96C242.637 525.617 245.112 525.403 247.3 524.526L257.42 533.488C259.342 535.192 260.136 537.836 259.471 540.316L258.802 542.812C258.64 543.419 258.018 543.779 257.407 543.615L215.943 532.505C215.334 532.342 214.971 531.725 215.136 531.112L215.804 528.616C216.469 526.136 218.478 524.243 220.995 523.728Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.6 527.143C236.212 526.235 233.423 524.211 231.514 521.576L234.221 521.022C235.698 522.88 237.734 524.303 240.186 524.96C242.637 525.617 245.112 525.403 247.301 524.526L249.38 526.368C246.411 527.693 242.986 528.051 239.6 527.143Z",
    fill: "#BED2F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1325_7193",
    x: 9.46191,
    y: 11.4377,
    width: 225.5,
    height: 648.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1325_7193",
    x: 114.06,
    y: 162.509,
    width: 158.029,
    height: 158.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_7193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1325_7193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1325_7193",
    x: 194.676,
    y: 451.694,
    width: 102.592,
    height: 102.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1325_7193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1325_7193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_7193",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1325_7193",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1325_7193",
    x1: 100,
    y1: -3.72381,
    x2: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4362CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1325_7193",
    x1: 106,
    y1: 0,
    x2: 106,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1325_7193",
    x1: 106,
    y1: 0,
    x2: 106,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1325_7193",
    x1: 70.076,
    y1: -2.65917,
    x2: -9.38009,
    y2: 77.5077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicInfo);
export default __webpack_public_path__ + "static/media/basic-info.c9e7d2f50d40c737dea110ee02a85afa.svg";
export { ForwardRef as ReactComponent };